export default {
  SET_PROJECTS_OVERVIEWS: (state, { actualsV1, actualsV2, materialsV1, materialsV2, etc }) => {
    state.actualsV1 = actualsV1;
    state.actualsV2 = actualsV2;
    state.materialsV1 = materialsV1;
    state.materialsV2 = materialsV2;
    state.etc = etc;
    state.overviewsDataLoaded = true;
  },
};
